import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {AccessJson} from "@amlCore/models";
import {RegistriesService} from "../../service";
import {RegistriesAccessEnum} from "@amlCore/enums";
import {TableService, UserService, VisitedService} from "@amlCore/services";
import {Utils} from "@amlCore/utils";
import {IDataResponse} from "@amlCore/interfaces";
import {InagentInfo} from "../../model/inagentInfo.model";


@Component({
  selector: 'app-registry-inagent-list',
  templateUrl: './inagentList.component.html'
})
export class InagentListComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = true;
  public isAll = false; // поиск по всем перечням

  constructor(private regSrv: RegistriesService,
              private userSrv: UserService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'number', dir: 'ASC'});
  }
  dataList: Array<InagentInfo> = [];
  id: string;
  access: AccessJson;
  goBack = Utils.goBack;
  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_INAGENT);
    this.activatedRoute.params.subscribe(params => {
      this.id = params.id;
      if (this.id === undefined) {
        this.isAll = true;
      }
      this.activatedRoute.queryParams.subscribe(
        data => {
          const paramsData = this.syncParams(data);
          paramsData.id = this.id;
          this.loadList(paramsData);
        });
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params) {
    const filter = this.getParams({...params, ...this.filter});
    this.navigate(filter);
  }

  public onSearch() {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  private loadList(params?: InagentInfo) {
    this.regSrv.getInagentList(this.getParams(params)).subscribe((data: IDataResponse<InagentInfo>) => {
      this.dataList = data.content;
      this.total = data.totalElements;
    });
  }
}
